export const ACCESS_TOKEN = "accessToken";
export const LOGGED_IN = "loggedIn";
export const DEFAULT_DATE_FORMAT = "MM/dd/yyyy";
export const TENANT_ID = "tenantId";
